import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';

const ScratchpadFloatingButton = ({ count = 0, onClick, isDarkMode }) => {
  const [shouldBounce, setShouldBounce] = useState(false);

  // Trigger bounce animation when the count changes
  useEffect(() => {
    if (count > 0) {
      setShouldBounce(true);
      const timer = setTimeout(() => setShouldBounce(false), 500);
      return () => clearTimeout(timer);
    }
  }, [count]);

  return (
    <div
      onClick={onClick}
      className={shouldBounce ? 'betslip-button-bounce' : ''}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: isDarkMode ? '#7c3aed' : '#7c3aed',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        // Sit above player modal + backdrop + odds-detail bottom sheet
        // (highest of those is 1210). Matches BetslipFloatingButton.
        zIndex: 1220,
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        userSelect: 'none',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
      }}
      title="Scratchpad"
    >
      {/* Notepad icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 4a2 2 0 0 1 2-2h9l4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M9 9h6M9 13h6M9 17h4"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>

      {count > 0 && (
        <Badge
          bg="danger"
          pill
          style={{
            position: 'absolute',
            top: '-5px',
            right: '-5px',
            fontSize: '0.7rem',
            minWidth: '22px',
            height: '22px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
          }}
        >
          {count}
        </Badge>
      )}
    </div>
  );
};

export default ScratchpadFloatingButton;
